import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-100 d-flex ml-2" }
const _hoisted_2 = { class: "w-75" }
const _hoisted_3 = { class: "w-75 d-flex cols-12 ml-2 mt-2" }
const _hoisted_4 = { class: "w-75 cols-5" }
const _hoisted_5 = { class: "text-label-large font-weight-bold" }
const _hoisted_6 = { class: "w-100 d-flex cols-7" }
const _hoisted_7 = { class: "w-75 d-flex cols-12 ml-2 mt-2" }
const _hoisted_8 = { class: "w-75 cols-5" }
const _hoisted_9 = { class: "text-label-large font-weight-bold" }
const _hoisted_10 = { class: "w-100 d-flex cols-7" }
const _hoisted_11 = { class: "w-75 d-flex cols-12 ml-2 mt-2" }
const _hoisted_12 = { class: "w-75 cols-5" }
const _hoisted_13 = { class: "text-label-large font-weight-bold" }
const _hoisted_14 = { class: "w-100 d-flex cols-7" }
const _hoisted_15 = { class: "w-75 d-flex cols-12 ml-2 my-2" }
const _hoisted_16 = { class: "w-75 cols-5" }
const _hoisted_17 = { class: "text-label-large font-weight-bold" }
const _hoisted_18 = { class: "w-100 d-flex cols-7" }
const _hoisted_19 = { class: "w-25 d-flex flex-column align-items-end pr-4 my-auto" }

import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import CopyElement from "@/components/CopyElement.vue";
import { formatDateTime } from '@/services/functions';
import DeliveryPlan from "@/types/DeliveryPlan";
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'RightContent',
  props: {
    modelValue: {},
    originDeliveryPlan: {},
    deliveryPlan: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const isOriginDeliveryPlan = computed(() => {
  return props.deliveryPlan.delivery_plan_id === props.originDeliveryPlan.delivery_plan_id;
})

function removeDeliveryPlan(deliveryPlan: DeliveryPlan | getDeliveryPlanVehicleInformation) {
  const index = props.modelValue.findIndex((plan) => plan.delivery_plan_id === deliveryPlan.delivery_plan_id);

  if (index !== -1) {
    modelValue.value.splice(index, 1);
  }
}

function changeFormat(dateTime: Date | string) {
  return typeof dateTime === 'string' ? formatDateTime(new Date(dateTime)) : formatDateTime(dateTime);
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: _normalizeClass(['w-100', { 'origin-delivery-plan-card': isOriginDeliveryPlan.value }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.rightPane.tripId')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(props.deliveryPlan.delivery_plan_id?.toString().slice(-7)) + " ", 1),
              _createVNode(CopyElement, {
                copyText: props.deliveryPlan.delivery_plan_id,
                size: "small"
              }, null, 8, ["copyText"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.rightPane.numberPlate')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(props.deliveryPlan.car_number), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.rightPane.leavingWarehouse')), 1)
            ]),
            _createElementVNode("div", _hoisted_14, _toDisplayString(changeFormat(props.deliveryPlan.leaving_warehouse_date_time)), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.rightPane.returningWarehouse')), 1)
            ]),
            _createElementVNode("div", _hoisted_18, _toDisplayString(changeFormat(props.deliveryPlan.returning_warehouse_date_time)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          (!isOriginDeliveryPlan.value)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                variant: "text",
                class: "w-25 mx-auto d-flex justify-content-center text-red",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (removeDeliveryPlan(props.deliveryPlan)))
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("span", { class: "my-auto material-symbols-outlined icon-24" }, " delete ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})